import { Modal, Radio } from 'antd';
import { Frequency } from '../../../types';
import { useEffect, useState } from 'react';
import { frequencies } from '../../../constants';
import { useTranslation } from 'react-i18next';

export interface SelectFrequencyProps {
  open: boolean;
  onConfirm: (frequency: Frequency) => void;
  onClose: () => void;
  defaultFrequency?: Frequency;
}

const SelectFrequency = ({
  open,
  onConfirm,
  onClose,
  defaultFrequency,
}: SelectFrequencyProps) => {
  const { t } = useTranslation();
  const [frequency, setFrequency] = useState<Frequency>();

  const handleConfirm = () => {
    onConfirm(frequency as Frequency);
  };

  useEffect(() => {
    setFrequency(defaultFrequency);
  }, [defaultFrequency]);

  return (
    <Modal
      open={open}
      title={t('select_frequency')}
      onOk={handleConfirm}
      onClose={onClose}
      onCancel={onClose}
      width={300}
    >
      <Radio.Group
        value={frequency}
        onChange={(e) => setFrequency(e.target.value)}
        options={frequencies}
        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
      />
    </Modal>
  );
};

export default SelectFrequency;
